import React from 'react';
import {Button} from '~/components/Button';
import {EditorInput} from '~/components/Controls/Editor';
import {IModalComponent} from '~/components/Modal';
import {ICreatedApiToken} from '~/modules/Profile/models/ApiToken';
import style from './ShowTokenModal.module.scss';

interface IShowTokenModalProps {
    token: ICreatedApiToken;
}

export const ShowTokenModal: IModalComponent<IShowTokenModalProps> = props => (
    <div className={style.container}>
        <div className={style.title}>API token</div>
        <p>Copy and save the token — you will not be able to see it again.</p>
        <EditorInput
            id="api-token"
            value={props.token.token}
            mode="text"
            disabled
            canCopy
            minLines={3}
            maxLines={3}
        />
        <div className={style.controls}>
            <Button onClick={props.close}>Close</Button>
        </div>
    </div>
);
